"use client";

import Head from "next/head";
import Banner from "./components/banner/banner.jsx";
import LifestylePop from "./components/lifestyle-pop/lifestyle-pop.jsx";
import Grid from "@mui/material/Grid";
import WordCard from "./components/card-gallery/cardgallery.jsx";
import Download from "./components/download/download.jsx";
import Slideshow from "./components/home-slideshow/slideshow.jsx";
import Membership from "./components/membership/type.jsx";
import App from "./components/VideoModal/app.js";

import "./components/join/join.css";

export default function Home() {
  const cards = [
    {
      title: "FLIGHTS",
      definition: "to 210+ countries",
      image:
        "https://nouf-flp-images.s3.af-south-1.amazonaws.com/843E_FLP+Reskin_Home+6.jpg",
      bgposition: "cardcenter",
    },
    {
      title: "CAR HIRE",
      definition: "in 150+ countries",
      image:
        "https://nouf-flp-images.s3.af-south-1.amazonaws.com/843E_FLP+Reskin_Home+7.jpg",
    },
    {
      title: "CRUISES",
      definition:
        "12 premier cruise lines & 160 luxury ships visiting 5,000 exotic ports of call",
      image:
        "https://nouf-flp-images.s3.af-south-1.amazonaws.com/843E_FLP+Reskin_Home+8.jpg",
      bgposition: "shipcardcenter",
    },
    {
      title: "TOURS & ACTIVITIES",
      definition: "up to 20% off 1,000,000+ tour activities",
      image: "https://nouf-flp-images.s3.af-south-1.amazonaws.com/camels.jpg",
    },
  ];

  const slideData = [
    {
      title: "SA's Best All Round",
      description: "Loyalty Programme",
      buttonLabel: "Watch Video",
      buttonLink: "https://www.youtube.com/watch?v=puieXm1xskc&t=3s",
      imageUrl:
        "https://nouf-flp-images.s3.af-south-1.amazonaws.com/843E_FLP+Reskin_Home-4.jpg",
      mobileImageUrl:
        "https://nouf-flp-images.s3.af-south-1.amazonaws.com/843E_FLP+Reskin_Home-3.jpg",
    },
  ];

  const options = {
    // Customize Flickity options here
    cellAlign: "left",
    contain: true,
    freeScroll: true,
    wrapAround: true,
    adaptiveHeight: true,
    autoPlay: 4000,
    prevNextButtons: false,
  };

  return (
    <div className="proj-cont">
      <Head>
        <title>Home Page</title>
        <meta
          name="First Loyalty Plus"
          content="First Loyalty Plus"
        />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Slideshow banners={slideData} options={options} />
      <LifestylePop
        backgroundImage="https://nouf-flp-images.s3.af-south-1.amazonaws.com/843E_FLP+Reskin_Home-01.jpg"
        title="Dining"
        subtext="<p>Up to R120 OFF at over 2,000 Restaurants</p>"
        // title2="Coffee"
        // subtext2="<p>BUY 1 GET 1 FREE</p>"
        // popUpContent="<div>
        //     <p></p>
        //     </div>"
        logo1={{ alt: "", src: "", visibility: false }}
        logo2={{ alt: "", src: "", visibility: false }}
        logo3={{ alt: "", src: "", visibility: false }}
        button1={{
          text: "Find out more",
          link: "/lifestyle",
          visibility: true,
          popup: false,
        }}
        button2={{
          text: "Restaurant finder",
          link: "/restaurant-finder",
          visibility: true,
          popup: false,
        }}
        contentAlign="left"
        popUpImage="/images/Dining_PopUp.jpg"
      />

      <LifestylePop
        backgroundImage="https://nouf-flp-images.s3.af-south-1.amazonaws.com/843E_FLP+Reskin_Home-2.jpg"
        title="Movies"
        subtext="<p>50% Off Movies and Popcorn &<br> Drink Combos at NuMetro Cinemas</p>"
        popUpContent="<div>
            <p></p>
            </div>"
        logo1={{ alt: "", src: "", visibility: false }}
        logo2={{ alt: "", src: "", visibility: false }}
        logo3={{ alt: "", src: "", visibility: false }}
        button1={{
          text: "Find out more",
          link: "/lifestyle",
          visibility: true,
          popup: false,
        }}
        button2={{
          text: "Restaurant finder",
          link: "/restaurant-finder",
          visibility: false,
          popup: false,
        }}
        contentAlign="right"
        popUpImage="/images/Dining_PopUp.jpg"
      />
      <LifestylePop
        backgroundImage="https://nouf-flp-images.s3.af-south-1.amazonaws.com/843E_FLP+Reskin_Home+3.jpg"
        title="SPA"
        subtext="<p>20% OFF unlimited spa treatments at La Vita Spas countrywide!<br> PLUS get one FREE treatment per year!</p>"
        popUpContent="<div>
            <p></p>
            </div>"
        logo1={{ alt: "", src: "", visibility: false }}
        logo2={{ alt: "", src: "", visibility: false }}
        logo3={{ alt: "", src: "", visibility: false }}
        button1={{
          text: "Find out more",
          link: "/lifestyle",
          visibility: true,
          popup: false,
        }}
        button2={{
          text: "Restaurant finder",
          link: "/restaurant-finder",
          visibility: false,
          popup: false,
        }}
        contentAlign="left"
        popUpImage="/images/Dining_PopUp.jpg"
      />
      <LifestylePop
        backgroundImage="https://nouf-flp-images.s3.af-south-1.amazonaws.com/843E_FLP+Reskin_Home.jpg"
        title="Best Holidays"
        subtext="<p>Up to 50% OFF over 15,000 SA Hotels & Resorts<br><b>PLUS</b><br>Up to 50% OFF over 500,000 International Hotels & Resorts</p>"
        popUpContent="<div>
            <p></p>
            </div>"
        logo1={{ alt: "", src: "", visibility: false }}
        logo2={{ alt: "", src: "", visibility: false }}
        logo3={{ alt: "", src: "", visibility: false }}
        button1={{
          text: "Find out more",
          link: "/holiday-travel",
          visibility: true,
          popup: false,
        }}
        button2={{
          text: "Restaurant finder",
          link: "/restaurant-finder",
          visibility: false,
          popup: false,
        }}
        contentAlign="right"
        popUpImage="/images/Dining_PopUp.jpg"
      />
      <Banner title="Travel" />
      <Grid container spacing={{ xs: 0, sm: 0, md: 0, lg: 0 }}>
        {cards.map((card, index) => (
          <Grid item xs={12} sm={12} md={3} lg={3} key={index}>
            <WordCard {...card} />
          </Grid>
        ))}
      </Grid>
      <LifestylePop
        backgroundImage="https://nouf-flp-images.s3.af-south-1.amazonaws.com/843E_FLP+Reskin_Home+10.jpg"
        title="Deals-4-u"
        subtext="<p>Up to 50% OFF the best local deals and seasonal specials</p>"
        popUpContent="<div>
            <p></p>
            </div>"
        logo1={{ alt: "", src: "", visibility: false }}
        logo2={{ alt: "", src: "", visibility: false }}
        logo3={{ alt: "", src: "", visibility: false }}
        button1={{
          text: "Find out more",
          link: "/deals-4-U",
          visibility: false,
          popup: false,
        }}
        button2={{
          text: "Explore Deals-4-U",
          link: "/deals-4-U",
          visibility: true,
          popup: false,
        }}
        contentAlign="left"
        popUpImage="/images/Dining_PopUp.jpg"
      />
      <LifestylePop
        backgroundImage="https://nouf-flp-images.s3.af-south-1.amazonaws.com/newconnect.jpg"
        title="Go Premium"
        subtext="<p>JOIN FLP CONNECT FOR R249pm<br>
            Get your monthly subscription back in airtime PLUS all the wonderful FLP Standard benefits.<br>
            For R249 p/m get R249 back in airtime EVERY month!</p>"
        popUpContent="<div>
            <p></p>
            </div>"
        logo1={{ alt: "", src: "", visibility: false }}
        logo2={{ alt: "", src: "", visibility: false }}
        logo3={{ alt: "", src: "", visibility: false }}
        button1={{
          text: "Find out more",
          link: "/FLP-connect",
          visibility: true,
          popup: false,
        }}
        button2={{
          text: "Restaurant finder",
          link: "/restaurant-finder",
          visibility: false,
          popup: false,
        }}
        contentAlign="right"
        popUpImage="/images/Dining_PopUp.jpg"
      />
      <Membership />
      <Download />
      <App />
    </div>
  );
}
